<template>
    <div class="min-h-full flex flex-col bg-gray-100">
        <Navigation :class="$props.navigationClass"
                    class="shrink-0"
        ></Navigation>

        <div v-if="$props.header || $slots.header || displayPromotionalAlert">
            <header v-if="$props.header"
                    class="py-4"
            >
                <Container class="space-y-4">
                    <PromotionalAlert v-if="displayPromotionalAlert" />

                    <div class="flex justify-between gap-4 flex-wrap lg:flex-nowrap items-end">
                        <div class="flex justify-between gap-4 flex-wrap lg:flex-nowrap">
                            <div class="grow flex flex-col items-start justify-end gap-2">
                                <Breadcrumbs v-if="$props.breadcrumbs.length > 0"
                                             :breadcrumbs="$props.breadcrumbs"
                                />

                                <h1 class="text-3xl font-bold tracking-tight text-gray-700">
                                    {{ $props.header }}
                                </h1>
                            </div>

                            <div class="flex items-end justify-between gap-2 flex-wrap">
                                <slot name="buttons" />
                            </div>
                        </div>

                        <img v-if="$props.headerImage"
                             :alt="$props.header"
                             :src="$props.headerImage"
                             class="shrink-0 w-auto h-22 bg-white object-cover rounded-lg"
                        >

                        <Advertisement class="hidden lg:block shrink-0 max-w-screen w-full lg:max-w-none lg:w-auto"
                                       type="desktop-banner"
                        />
                    </div>

                    <slot name="header" />
                </Container>
            </header>

            <template v-else-if="$slots.header">
                <Container class="mt-4" v-if="$props.breadcrumbs.length > 0">
                    <PromotionalAlert v-if="displayPromotionalAlert" />

                    <Breadcrumbs v-if="$props.breadcrumbs.length > 0"
                                 :breadcrumbs="$props.breadcrumbs"
                    />

                    <Advertisement class="lg:hidden"
                                   type="desktop-banner"
                    />
                </Container>

                <slot name="header" />
            </template>

            <template v-else-if="displayPromotionalAlert">
                <Container class="my-4">
                    <PromotionalAlert />
                </Container>
            </template>
        </div>

        <main class="flex-1 pb-4">
            <slot />
        </main>

        <Footer class="shrink-0 bg-gray-900" />

        <InertiaHead>
            <title v-if="$props.title">
                {{ $props.title }} - Dogdom
            </title>

            <title v-else>
                Dogdom
            </title>
        </InertiaHead>
    </div>
</template>

<script setup>
import {Head as InertiaHead} from '@inertiajs/vue3';
import Footer                 from '@/js/Layouts/Components/Footer.vue';
import Navigation             from '@/js/Layouts/Components/Navigation.vue';
import Container              from '@/js/Components/Container.vue';
import Advertisement          from '@/js/Components/Advertisement.vue';
import Breadcrumbs            from '@/js/Components/Breadcrumbs.vue';
import PromotionalAlert       from '@/js/Components/PromotionalAlert.vue';
</script>

<script>
export default {
    props: {
        title:           String,
        header:          String,
        breadcrumbs:     {
            type:    Array,
            default: [],
        },
        navigationClass: {
            type:    String,
            default: 'bg-linear-to-br from-brand-500 to-brand-700',
        },
        headerImage:     {
            type:    null,
            default: undefined,
        },
    },

    data() {
        return {
            displayPromotionalAlert: false,
        };
    },
};
</script>
